import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#0D0D0D] text-gray-400 py-8 md:py-12 px-4 md:px-6 border-t border-[#D4AF37]/20" data-id="element-110">
      <div className="max-w-6xl mx-auto" data-id="element-111">
        <div className="text-center space-y-4 md:space-y-6" data-id="element-112">
          <div className="flex items-center justify-center gap-2 mb-4 md:mb-6" data-id="element-113">
            <div className="w-2 h-2 bg-[#D4AF37] rounded-full" data-id="element-114"></div>
            <p className="font-['Playfair_Display'] text-[#D4AF37] text-lg md:text-xl" data-id="element-115">
              Alexa Narvaez Closer Digital
            </p>
            <div className="w-2 h-2 bg-[#D4AF37] rounded-full" data-id="element-116"></div>
          </div>
          <p className="font-['Inter'] text-xs md:text-sm leading-relaxed max-w-4xl mx-auto px-4" data-id="element-117">
            Este sitio no forma parte de Meta/Facebook o Instagram. Los
            testimonios y resultados mostrados son reales y verificables, pero
            representan casos extraordinarios. Los resultados individuales
            dependerán de tu dedicación, disciplina y ejecución del sistema. No
            garantizamos ingresos específicos.
          </p>
          <div className="pt-6 md:pt-8 border-t border-[#D4AF37]/20" data-id="element-118">
            <p className="font-['Inter'] text-xs text-gray-500" data-id="element-119">
              © 2025 Alexa Narvaez Closer Digital. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}